export const LinearSize = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M3.96289 10H15.9629M3.96289 10L5.96289 7M3.96289 10L5.96289 13M15.9629 10L13.9629 7M15.9629 10L13.9629 13M18.9629 19V1M0.962891 19V1"
                stroke="#838280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}